import React from "react";

const Card3 = ({qrCodeRef, logo, profile, candidateName, studentAdmission, studentClass, studentSection, qrData, fathersName, schoolName, mobile, schoolMobile}) => {
  return (
    <div class="container ad-container" ref={qrCodeRef}>
      <div class="add-card">
        <div class="add-header">
          <div className="add-school">
            <img src={logo} alt="Profile" className="add-schoollogo" />
            <div>
              <h5>{schoolName}</h5>
            </div>
            <div class="addqr-code">
              <img
                src={qrData}
                alt="Profile"
                X
                style={{
                  width: 100,
                  marginTop: "10px",
                }}
              />
            </div>
          </div>
        </div>
        <div>
          <span class="add-session">{schoolName}</span>
        </div>
        <div class="add-row">
          <div class="col-md-6">
            <div class="add-info">
              <p>
                <strong>Name:</strong> {candidateName}
              </p>
              <p>
                <strong>Fathers name:</strong> {fathersName}
              </p>
              <p>
                <strong>Class:</strong> {studentClass} - {studentSection}
              </p>
              <p>
                <strong>Admission no:</strong> {studentAdmission}
              </p>
              <p>
                <strong>Mobile:</strong> {mobile}
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="add-student">
              <img src={profile} alt="Profile" />
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card3;
